import { render, staticRenderFns } from "./DateTermInput.vue?vue&type=template&id=1601974a&scoped=true&"
import script from "./DateTermInput.vue?vue&type=script&lang=ts&"
export * from "./DateTermInput.vue?vue&type=script&lang=ts&"
import style0 from "./DateTermInput.vue?vue&type=style&index=0&id=1601974a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1601974a",
  null
  
)

export default component.exports